import { FC, ReactNode } from 'react'
import {
  AvailabilityViewerDiagnostic,
  AvailabilityViewerDiagnosticType,
} from './Diagnostic'
import {
  AvailabilityViewerSeatingArea,
  AvailabilityViewerSeatingAreaType,
} from './SeatingArea'

const AvailabilityViewer: FC &
  AvailabilityViewerSeatingAreaType &
  AvailabilityViewerDiagnosticType = (): ReactNode => <></>

AvailabilityViewer.SeatingArea = AvailabilityViewerSeatingArea
AvailabilityViewer.Diagnostic = AvailabilityViewerDiagnostic

export default AvailabilityViewer
